// extracted by mini-css-extract-plugin
export var hideEditor = "_n5-2";
export var infoIcon = "_n5-3";
export var label = "_n5-1";
export var labelContainer = "_n5-0";
export var readonlyText = "_n5-4";